
import { FaPhoneSquareAlt } from 'react-icons/fa';
import { MdEmail } from 'react-icons/md';

interface IFuncionarioISecaoItemProps {
    nome?: string;
    telefone?: string;
    email?: string;
    email2?: string;
    lattes?: string;
}

const FuncionarioISecaoItem = ({ email, nome, telefone, lattes, email2 }: IFuncionarioISecaoItemProps) => {
    const splitEmail = (email: string) => {
        return email.replace(/\./g, '. ').replace(/@/g, ' @');
    }

    return (
        <div className='flex flex-col gap-[3px] mt-[10px] mb-[20px]'>

            <div className='flex gap-[10px] items-center'>
                <p className='font-bold text-[16px]'>{nome}</p>
                {lattes && (
                    <>
                        |
                        <a className='text-colorPrimary font-bold underline-none hover:underline' target='_blank' href={lattes}>Lattes</a>
                    </>
                )}
            </div>

            <div className='flex items-center gap-[12px] font-normal text-[14px]'>
                <FaPhoneSquareAlt color='#004781' size={20} />
                {telefone}
            </div>

            <div className='flex items-center gap-[12px] font-normal text-[14px]'>
                <MdEmail color='#004781' size={20} />
                <a href={`mailto:${email}`} className='text-colorPrimary font-normal decoration-none max-w-sm'>{splitEmail(email || '')}</a>
            </div>


            {email2 && (
                <div className='flex items-center gap-[12px] font-normal text-[14px]'>
                    <MdEmail color='#004781' size={20} />
                    <a href={`mailto:${email2}`} className='text-colorPrimary font-normal decoration-none max-w-sm'>{splitEmail(email2 || '')}</a>
                </div>
            )}
        </div>
    );
}

export { FuncionarioISecaoItem }